<template>
  <div class="info-account">
    <!-- 保证金预存账户信息 -->
    <div class="service-account">
      <div class="account-title">
        <span class="account-title-main">
          {{ guaranteePreSave.subAccountNo }}
        </span>
        <span>[保证金专属预存账号]</span>
      </div>
      <el-row type="flex" class="row-flex" :gutter="10">
        <el-col class="col-item col-item1">
          <div class="info-desc">
            <span class="desc-label">银行</span>
            <span class="desc-value">{{ guaranteePreSave.bank }}</span>
          </div>
        </el-col>
        <el-col class="col-item col-item2">
          <div class="info-desc">
            <span class="desc-label">账户名称</span>
            <span class="desc-value">
              {{ guaranteePreSave.subAccountName }}
            </span>
          </div>
        </el-col>
        <el-col class="col-item col-item3">
          <div class="info-desc">
            <span class="desc-label">余额</span>
            <span class="desc-value">
              {{ guaranteePreSave.useTotalAmount }}元
            </span>
          </div>
        </el-col>
        <el-col class="col-item col-item4">
          <div class="info-desc">
            <span class="desc-label">可退款金</span>
            <span class="desc-value">
              {{ guaranteePreSave.remainTotalAmount }}元
            </span>
          </div>
        </el-col>
        <el-col class="col-item col-item5">
          <div class="info-desc">
            <span class="desc-label">不可退款金额</span>
            <span class="desc-value">
              {{ guaranteePreSave.consumeTotalAmount }}元
            </span>
            <div v-if="isShowTip" class="desc-tip desc-tip--bottom">
              有占用额度，该金额暂时不支持退款
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="service-tip">
      <div class="tip-title">重要提示</div>
      <ol>
        <li>
          请
          <span class="text-danger">线下向保证金预存账号打款</span>
          ，打款时请反复比对预存账号
          <span class="text-danger">切勿与保证金缴纳账户混淆</span>
          ，保证金额度=预存账号余额
        </li>
        <li>
          <span class="text-danger">
            线下打款的账户<span class="text-bold">请务必保证支持原路退款，切勿使用只出账不进账的账户打款！</span>
          </span>
        </li>
        <li>
          建议至少预存2千额度，方便参与项目，减少频繁打款。
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GuaranteePreSaveAccount',

  computed: {
    ...mapState('finance', ['guaranteePreSave']),

    isShowTip() {
      return Number(this.guaranteePreSave?.consumeTotalAmount || 0) > 0
    }
  },

  created() {
    this.getPreSaveAccount()
  },

  methods: {
    /**
     * 获取预存账户信息
     */
    getPreSaveAccount() {
      this.$store.dispatch('finance/getGuaranteePreSave')
    }
  }
}
</script>

<style scoped lang="scss">
.info-account {
  width: 100%;
  background: $white-color;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  padding: 24px;
  align-items: flex-start;
}

.service-account {
  flex: 1;
  .account-title {
    color: $second-text-color;
    font-size: 14px;
    margin-bottom: 24px;

    .account-title-main {
      color: $text-color;
      font-size: 24px;
      line-height: 24px;
    }
  }

  .row-flex {
    .col-item {
      width: 50%;
    }

    .col-item5 {
      width: 100%;
    }
  }

  .info-desc {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 18px;

    .desc-label {
      color: $second-text-color;
      &:after {
        content: '：';
      }
    }

    .desc-value {
      color: $text-color;
    }

    .desc-tip {
      color: $third-text-color;
      font-size: 14px;
    }
  }
}

.service-tip {
  flex: 1.5;
  margin-left: 40px;
  background: $warning-fourth-color;
  border: 1px solid $warning-second-color;
  border-radius: 4px;
  padding: 16px 22px;

  .tip-title {
    color: $danger-color;
    font-size: 16px;
    margin-bottom: 12px;

    &:after {
      content: '：';
    }
  }

  ol {
    padding: 0 0 0 16px;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 0;
    color: $second-text-color;
  }
}

@media only screen and (max-width: 1280px) {
  .info-account {
    display: block;
  }
  .service-account {
    width: 100%;

    .row-flex {
      .col-item1, .col-item3, .col-item4 {
        width: 30%;
      }

      .col-item2 {
        width: 70%;
      }

      .col-item5 {
        width: 40%;
      }
    }

    .desc-tip {
      display: inline;
      margin-left: 10px;
    }
  }

  .service-tip {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
